import { request } from '../../utils/request';

export type StoreOrderCounts = {
  /** Paid by customer, awaiting the store to pack */
  awaiting_pack: number;
  /** Marked packed, awaiting courier pickup */
  packed: number;
  shipped: number;
  delivered: number;
  settled: number;
  /** Sum of all non-terminal states — used as a single badge value */
  active: number;
};

export const getStoreOrderCounts = (
  store_id: number,
  authToken: string
): Promise<StoreOrderCounts> => {
  const filter = new URLSearchParams({ store_id: `${store_id}` });
  return request({
    method: 'GET',
    url: `/products/order-counts?${filter.toString()}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
